import axios from "axios";

const configAxios = axios.defaults;

export async function getPermissionsUser(teamSlag) {
  // запрашивает скопы пользователя и человекочитаемые названия
  // Вынести и запрашивать один раз
  const urlAllPermissions = configAxios.baseURL + "/api/v1/scopes/all";
  let url;

  if (teamSlag !== null) {
    url = configAxios.baseURL + `/api/v1/scopes/?team=${teamSlag}`;
  } else {
    url = configAxios.baseURL + "/api/v1/scopes/";
  }

  let scopes;
  let allScopes;

  try {
    // Запрашиваем скопы пользователя
    await axios.get(url).then((res) => {
      scopes = res.data;
    });
    // Запрашиваем все скопы
    await axios.get(urlAllPermissions).then((res) => {
      allScopes = res.data;
    });

    return { scopes, allScopes };
  } catch (error) {
    console.error(error);
  }
}

function clearLocalStorage() {
  const redirectUrl = localStorage.getItem("zarboRedirectUrl");
  localStorage.removeItem("zarboAccessToken");
  localStorage.removeItem("zarboRefreshToken");
  localStorage.removeItem("selectedTeamSlug");
  localStorage.removeItem("selectedTab");
  localStorage.removeItem("zarbo-selected-collection");
  localStorage.removeItem("lastOpenYoutubePlaylist");
  localStorage.removeItem("lastOpenPlaylist");
  localStorage.removeItem("oauthConnected");
  localStorage.removeItem("zarboExpireRefresh");
  if (redirectUrl) {
    localStorage.setItem("zarboRedirectUrl", redirectUrl);
  }
}

export async function logoutUser() {
  const expRefresh = Number(localStorage.getItem("zarboExpireRefresh")) * 1000;
  const dateNow = new Date();

  // Save current URL before redirecting, but only if it's not login or oauth or root
  const currentPath = window.location.pathname;
  if (
    currentPath !== "/" &&
    currentPath !== "/login" &&
    !currentPath.startsWith("/oauth") &&
    !currentPath.startsWith("/social")
  ) {
    const fullPath = window.location.pathname + window.location.search + window.location.hash;
    localStorage.setItem("zarboRedirectUrl", fullPath);
  }

  if (import.meta.env.DEV) {
    // DEV only
    clearLocalStorage();
    window.location.replace("https://develop.zarbo.works:8080/login");
    return;
  }

  if (localStorage.getItem("zarboAccessToken") === null || dateNow >= expRefresh) {
    clearLocalStorage();
    window.location.replace(`${configAxios.baseURL}/api/v1/auth/social/login/keycloak/`);
    console.warn("Токен истек");
    return;
  }
  // const url = config.baseURL + "/api/v1/auth/social/connections/disconnect";
  const url = configAxios.baseURL + "/api/v1/auth/logout/";
  const data = { refresh: localStorage.getItem("zarboRefreshToken") };
  try {
    await axios.post(url, data);
  } catch (error) {
    console.error(error);
  } finally {
    clearLocalStorage();
    window.location.replace(`${configAxios.baseURL}/api/v1/auth/social/login/keycloak/`);
  }
}

export async function getYoutubePlaylist(config) {
  const url = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${config.YOUTUBE_PLAYLIST_ID}&key=${import.meta.env.VITE_API_KEY_YOUTUBE}`;

  try {
    const resp = await axios.get(url);

    return resp.data;
  } catch (error) {
    console.error(error);

    return [];
  }
}

export async function getScopes(teamSlag) {
  // запрашивает скопы пользователя
  let url;

  if (teamSlag !== null) {
    url = configAxios.baseURL + `/api/v1/scopes/?team=${teamSlag}`;
  } else {
    url = configAxios.baseURL + "/api/v1/scopes/";
  }

  const res = await axios.get(url);
  return res.data;
}

export async function changeWidgetParams(param, config, id, productId) {
  let url;

  if (productId && Object.keys(param).includes("ar_placement")) {
    url = configAxios.baseURL + "/api/v1/products/" + productId + "/";
  } else {
    url = configAxios.baseURL + "/api/v1/widgets/" + id + "/";
  }

  try {
    return await axios.patch(url, param);
  } catch (error) {
    console.error(error);

    return {};
  }
}
